import { render, staticRenderFns } from "./BenefitsList.vue?vue&type=template&id=6176565d"
import script from "./BenefitsList.js?vue&type=script&lang=js&external"
export * from "./BenefitsList.js?vue&type=script&lang=js&external"
import style0 from "./BenefitsList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports